import { object, number } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

import { MAX_EVENT_LIMIT } from './constants'

export const getValidationSchema = () => object({
  dailyLimit: number()
    .integer()
    .typeError(I18n.t('errors.messages.not_a_number'))
    .min(0, I18n.t('errors.messages.greater_than', { count: 0 }))
    .max(MAX_EVENT_LIMIT, I18n.t('errors.messages.less_than_or_equal_to', { count: MAX_EVENT_LIMIT })),
  weeklyLimit: number()
    .integer()
    .typeError(I18n.t('errors.messages.not_a_number'))
    .min(0, I18n.t('errors.messages.greater_than', { count: 0 }))
    .max(MAX_EVENT_LIMIT, I18n.t('errors.messages.less_than_or_equal_to', { count: MAX_EVENT_LIMIT })),
  monthlyLimit: number()
    .integer()
    .typeError(I18n.t('errors.messages.not_a_number'))
    .min(0, I18n.t('errors.messages.greater_than', { count: 0 }))
    .max(MAX_EVENT_LIMIT, I18n.t('errors.messages.less_than_or_equal_to', { count: MAX_EVENT_LIMIT })),
})
